import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CompanylistService } from '~features/company/companylist.service';

import { SectorToastService } from './sector-toast.service';

@Component({
  selector: 'app-sector-toast',
  templateUrl: './sector-toast.component.html',
  imports: [RouterLink],
})
export class SectorToastComponent {
  private sectorToastService = inject(SectorToastService);
  private companyListService = inject(CompanylistService);

  isVisible = this.sectorToastService.isVisible;
  sector = this.sectorToastService.sector;
  companyTicker = this.sectorToastService.companyTicker;

  companiesInSector = computed(() => {
    if (!this.sector()) return [];
    return this.companyListService
      .getCompaniesBySector(this.sector()!)
      .filter((company) => company.companyTicker !== this.companyTicker())
      .sort((a, b) => a.name.localeCompare(b.name));
  });

  toggleVisibility() {
    this.sectorToastService.toggle();
  }
}
